import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

export const useMeta = () => {
  const { data: user } = useUser();
  const {
    isAuthenticatedUser,
    isLiteUser,
    isStudent,
    isParent,
    canStartPremiumTrial,
  } = getUserProperties(user);
  return {
    isAuthenticatedUser,
    isLiteUser,
    isStudent,
    isParent,
    canStartPremiumTrial,
  };
};

export default useMeta;
